module.exports = __webpack_public_path__ + "img/info-item-1.539c9830.png";